import { useCallback, useState } from 'react';
import mapboxgl from 'mapbox-gl';
import { getUnpaddedBounds } from '../helpers/get-unpadded-bounds';

export function useViewport() {
  let [ zoom, setZoom ] = useState();
  let [ map, setMap ] = useState();
  let [ viewport, setViewport ] = useState();
  let [ bounds, setBounds ] = useState();

  let fitBounds = useCallback(bounds => {
    if (!bounds || !bounds.length) return;

    let lowestLat = Math.min(...bounds.map(x => x[0]));
    let lowestLng = Math.min(...bounds.map(x => x[1]));

    let highestLat = Math.max(...bounds.map(x => x[0]));
    let highestLng = Math.max(...bounds.map(x => x[1]));

    let formattedBounds = new mapboxgl.LngLatBounds(
      new mapboxgl.LngLat(lowestLng, lowestLat),
      new mapboxgl.LngLat(highestLng, highestLat)
    );

    setBounds(formattedBounds);
    if (map) map.fitBounds(formattedBounds, { padding: 64, duration: 1500 });
  }, [map]);

  let onMapInit = useCallback(map => {
    setMap(map);
    setViewport(getUnpaddedBounds(map));
    setZoom(map.getZoom());
  }, []);

  let onViewportEvent = useCallback((event) => {
    setViewport(getUnpaddedBounds(event.target));
    setZoom(event.target.getZoom());
  }, []);

  return {
    zoom,
    map,
    viewport,
    bounds,

    fitBounds,

    onMapInit,
    onViewportEvent,
  };
}
